import type { ReactNode } from "react";

/** Markdown のリンク。アプリの画面を置き換えないよう、ブラウザの新しいタブで開く。 */
export function MarkdownLink({ href, children }: { href?: string; children?: ReactNode }) {
	return (
		<a href={href} className="text-accent underline" target="_blank" rel="noopener noreferrer">
			{children}
		</a>
	);
}
